// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../basic-warranty-estimator/state/report';
import actions from '../../actions-list';

const createBasicWarrantyEstimatorReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_BASIC_WARRANTY_ESTIMATOR_REPORT_SUCCESS]: createBasicWarrantyEstimatorReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: createBasicWarrantyEstimatorReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/basic-warranty-estimator/reducers/report.js